import { createApp, h } from "vue"
import ElementPlus from "element-plus"
import ElementPlusLocale from "element-plus/lib/locale/lang/ru"
// import "./registerServiceWorker"
// @ts-ignore
import { App, plugin } from "@inertiajs/inertia-vue3"
import { InertiaProgress } from "@inertiajs/progress"

const el = document.getElementById("app")

createApp({
    render: () =>
        h(App, {
            initialPage: JSON.parse(el?.dataset?.page as string),
            resolveComponent: (name: string) => require(`./Pages/${name}`).default,
        }),
})
    .use(plugin)
    .use(ElementPlus, { locale: ElementPlusLocale })
    .mount(el as Element)

InertiaProgress.init()
